import { morningQuestionsToDo } from 'app/redux/reducers/Question/morningQuestion.reducer';
import { morningQuestionsStore } from 'app/redux/rootReducer';

export function selectMorningQuestion(state) {
    return state[morningQuestionsStore][morningQuestionsToDo];
}
